// import 'lazysizes'
import './components/Sections.js'
import './components/Project.js'
import './components/InfiniteScroll.js'
import './components/Ultralazy.js'
import './components/Sticky.js'
import './components/InlineCycle.js'
import './components/InlineSlideshow.js'
import './components/InlineVideo.js'
import operator from './lib/operator.js'
import store from './store'
import tabs from './lib/new-tabify.js'
tabs()

const app = operator(['[data-operator]', 'body'])

let loadingTimeout = null

app.on('navigate', state => {
  // This timeout ensures that the loading cursor is only
  // shown when a link takes longer than 250ms to load
  loadingTimeout = setTimeout(() => {
    document.documentElement.classList.add('loading')  
  }, 250)
})

app.on('after', ({ previousDocument, location }) => {
  // Clear loading timeout
  clearTimeout(loadingTimeout)
  loadingTimeout = null
  document.documentElement.classList.remove('loading')

  // Update title
  document.title = previousDocument.title

  // Update route
  window.history.pushState({}, '', location)

  // Update opengraph
  let opengraphTags = [...previousDocument.querySelectorAll('[property^="og:"]')]
  opengraphTags.forEach(tag => {
    let existingOpengraphTag = document.querySelector(`[property="${tag.getAttribute('property')}"`)
    if (existingOpengraphTag) existingOpengraphTag.content = tag.content
  })

  // Update body classes
  let oldBodyClasses = [...previousDocument.body.classList]
  let newBodyClasses = [...document.body.classList]
  let classesToRemove = newBodyClasses.filter(x => !oldBodyClasses.includes(x))
  let classesToAdd = oldBodyClasses.filter(x => !newBodyClasses.includes(x))
  document.body.classList.remove(...classesToRemove)
  document.body.classList.add(...classesToAdd)

  // Set hash
  setHash(store.state.active)

  // Scroll position
  if (window.innerWidth < 960) {
    window.scrollTo(0, 0)
  } else {
    document.getElementById('container').scroll({ top: 0 })
  }
})

app.on('hash', ({ hash }) => {
  handleHash(hash)
})

store.listen(['active'], ({ active }) => {
  setHash(active)
})

function setHash (active) {
  if (active && window.location.pathname === '/') {
    history.replaceState({}, '', `#${active}`)
  }
}

function handleHash (hash) {
  // this is a programmatic scroll
  store.hydrate({ programmaticScroll: true })()
  const target = window.innerWidth < 960
    ? document.querySelector(`[data-section="${hash}"][data-mobile]`)
    : document.querySelector(`[data-section="${hash}"][data-desktop]`)

  if (target) {
    target.scrollIntoView()
    // directly set active based on hash value
    store.hydrate({ active: hash })()
    // unset programmatic scroll after slight delay
    // so we can start picking up scroll events again
    setTimeout(() => {
      store.hydrate({ programmaticScroll: false })()
    }, 250)
  }
}

if (window.location.hash) {
  let hash = window.location.hash.substr(1)
  // skip jumping to project if it is the first
  const target = window.innerWidth < 960
    ? document.querySelector(`[data-section="${hash}"][data-mobile]`)
    : document.querySelector(`[data-section="${hash}"][data-desktop]`)
  const index = [...target.parentElement.children].indexOf(target)
  if (index > 0) {
    handleHash(hash)
  }
}

// maintain scroll-to-top shortcut functionality
window.addEventListener('keydown', e => {
  if (window.innerWidth >= 960) {
    if (e.metaKey && e.keyCode === 38) {
      document.getElementById('images').scroll({ top: 0 })
      // document.getElementById('images').scroll({ top: 0, behavior: 'smooth' })
    }
  }
})

if (typeof InstallTrigger !== 'undefined') {
  document.documentElement.classList.add('is-firefox')
}